import clsx from 'clsx'

import RowSkeleton from '@/components/skeletons/RowSkeleton'

interface ShopCardSkeletonProps {
  className?: string
}

const ShopCardSkeleton = ({ className }: ShopCardSkeletonProps) => {
  return (
    <div className={clsx('space-y-4', className)}>
      <div className="flex flex-col gap-5 rounded-xl border border-slate-300 p-4 pb-[45px] tablet:flex-row tablet:gap-6 tablet:p-6">
        <RowSkeleton className="h-[206px] w-full overflow-hidden rounded-md tablet:h-[202px] tablet:w-[202px] desktop:h-[188px] desktop:w-[216px]" />
        <div className="flex flex-auto flex-col">
          <div className="mb-[17.5px] flex flex-col gap-1 tablet:mb-[54.5px] tablet:gap-2 desktop:mb-[28.5px]">
            <RowSkeleton className="h-5 w-[238px] tablet:h-6 tablet:w-[282px]" />
            <RowSkeleton className="h-5 w-[145px] tablet:w-[146px]" />
          </div>
          <RowSkeleton className="mb-[17.5px] h-[43px] w-full max-w-[500px] tablet:mb-[54.5px] desktop:mb-[22.5px]" />
          <div className="flex flex-row items-end justify-between gap-5">
            <div className="flex flex-col gap-1">
              <RowSkeleton className="h-5 w-[114px] tablet:w-[186px] desktop:h-4 desktop:w-[116px]" />
              <RowSkeleton className="h-5 w-[217px] tablet:hidden desktop:block desktop:h-4 desktop:w-[159px]" />
            </div>
            <RowSkeleton className="hidden h-5 w-[146px] desktop:block" />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-5 rounded-xl border border-slate-300 p-4 pb-[45px] tablet:flex-row tablet:gap-6 tablet:p-6">
        <RowSkeleton className="h-[206px] w-full overflow-hidden rounded-md tablet:h-[202px] tablet:w-[202px] desktop:h-[188px] desktop:w-[216px]" />
        <div className="flex flex-auto flex-col">
          <div className="mb-[17.5px] flex flex-col gap-1 tablet:mb-[54.5px] tablet:gap-2 desktop:mb-[28.5px]">
            <RowSkeleton className="h-5 w-[238px] tablet:h-6 tablet:w-[282px]" />
            <RowSkeleton className="h-5 w-[145px] tablet:w-[146px]" />
          </div>
          <RowSkeleton className="mb-[17.5px] h-[43px] w-full max-w-[500px] tablet:mb-[54.5px] desktop:mb-[22.5px]" />
          <div className="flex flex-row items-end justify-between gap-5">
            <div className="flex flex-col gap-1">
              <RowSkeleton className="h-5 w-[114px] tablet:w-[186px] desktop:h-4 desktop:w-[116px]" />
              <RowSkeleton className="h-5 w-[217px] tablet:hidden desktop:block desktop:h-4 desktop:w-[159px]" />
            </div>
            <RowSkeleton className="hidden h-5 w-[146px] desktop:block" />
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-5 rounded-xl border border-slate-300 p-4 pb-[45px] tablet:flex-row tablet:gap-6 tablet:p-6">
        <RowSkeleton className="h-[206px] w-full overflow-hidden rounded-md tablet:h-[202px] tablet:w-[202px] desktop:h-[188px] desktop:w-[216px]" />
        <div className="flex flex-auto flex-col">
          <div className="mb-[17.5px] flex flex-col gap-1 tablet:mb-[54.5px] tablet:gap-2 desktop:mb-[28.5px]">
            <RowSkeleton className="h-5 w-[238px] tablet:h-6 tablet:w-[282px]" />
            <RowSkeleton className="h-5 w-[145px] tablet:w-[146px]" />
          </div>
          <RowSkeleton className="mb-[17.5px] h-[43px] w-full max-w-[500px] tablet:mb-[54.5px] desktop:mb-[22.5px]" />
          <div className="flex flex-row items-end justify-between gap-5">
            <div className="flex flex-col gap-1">
              <RowSkeleton className="h-5 w-[114px] tablet:w-[186px] desktop:h-4 desktop:w-[116px]" />
              <RowSkeleton className="h-5 w-[217px] tablet:hidden desktop:block desktop:h-4 desktop:w-[159px]" />
            </div>
            <RowSkeleton className="hidden h-5 w-[146px] desktop:block" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShopCardSkeleton
